import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchVisitsOut = async (site_id: any) => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/visits/${site_id}out`);
  const visits = await result.json();
  return visits;
};

export default fetchVisitsOut;
